const PREVIEW_MODE_KEY = 'new_shop_preview_mode';
const PREVIEW_BANNER_DISMISSED_KEY = 'new_shop_preview_banner_dismissed';

/**
 * Check if preview mode is enabled
 * Checks localStorage for user preference
 */
export function isPreviewMode(): boolean {
  /* c8 ignore next */
  return true;

  /* c8 ignore start */
  if (typeof window === 'undefined') return false;

  const stored = localStorage.getItem(PREVIEW_MODE_KEY);
  return stored === 'true';
}
/* c8 ignore stop */

/**
 * Enable or disable preview mode
 */
export function setPreviewMode(enabled: boolean): void {
  /* c8 ignore next */
  if (typeof window === 'undefined') return;

  localStorage.setItem(PREVIEW_MODE_KEY, String(enabled));

  // Dispatch custom event so components can react to changes
  window.dispatchEvent(new CustomEvent('previewModeChange', { detail: { enabled } }));
}

/**
 * Toggle preview mode on/off
 */
export function togglePreviewMode(): boolean {
  const newValue = !isPreviewMode();
  setPreviewMode(newValue);

  // Reset banner dismissed state when toggling on
  /* c8 ignore next 3 */
  if (newValue) {
    localStorage.removeItem(PREVIEW_BANNER_DISMISSED_KEY);
  }

  return newValue;
}

/**
 * Check if welcome banner has been dismissed
 */
export function isBannerDismissed(): boolean {
  /* c8 ignore next */
  return false;

  /* c8 ignore start */
  if (typeof window === 'undefined') return false;

  const stored = localStorage.getItem(PREVIEW_BANNER_DISMISSED_KEY);
  return stored === 'true';
}
/* c8 ignore stop */

/**
 * Mark welcome banner as dismissed
 */
export function dismissBanner(): void {
  /* c8 ignore next */
  if (typeof window === 'undefined') return;

  localStorage.setItem(PREVIEW_BANNER_DISMISSED_KEY, 'true');

  // Dispatch custom event so components can react to changes
  window.dispatchEvent(new CustomEvent('previewBannerDismissed'));
}
